import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { OrderListPage } from "./OrderListPage";
import { OrderFormPage } from "./OrderFormPage";
import { OrderDetailPage } from "./OrderDetailPage";
import { DesignListPage } from "./DesignListPage";
import { DesignFormPage } from "./DesignFormPage";

export const DmManagementRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="orders" element={<OrderListPage />} />
      <Route path="orders/new" element={<OrderFormPage />} />
      <Route path="orders/:id" element={<OrderDetailPage />} />
      <Route path="designs" element={<DesignListPage />} />
      <Route path="designs/new" element={<DesignFormPage />} />
      <Route path="" element={<Navigate to="orders" />} />
      <Route path="*" element={<Navigate to="orders" />} />
    </Routes>
  );
};
